<template>
    <div  v-if="data">
        <div v-for="(value, key) in data" v-bind:key="key">
            <Fieldset>
                <template #legend>
                    {{ key }}
                </template>
                <DataTable 
                    :loading="!value" 
                    :value="value.details ? value.details : null" 
                    responsiveLayout="scroll" 
                    class="p-datatable-sm editable-cells-table"
                    rowGroupMode="rowspan"
                    groupRowsBy="value.order.Transporter_Code"
                    >
                    <Column field="Item_No" :header="$t('item_no')" key="Item_No">  
                    </Column>
                    <Column field="Material_Name" header="Material" key="Material_Name" >
                    </Column>
                    <Column field="Qty" :header="$t('order_qty')" key="Active" style="width:15%">
                        <template #body="slotProps">
                            {{this.$formatNumber(slotProps.data[slotProps.column.props.field])}}
                        </template>
                        <!-- <template #footer>
                            {{this.$formatNumber(subTotalQty(value.details))}}
                        </template> -->
                    </Column>
                    <Column field="real_qty" :header="$t('real_qty')" key="Active" style="width:15%">
                        <template #body="slotProps">
                            {{this.$formatNumber(slotProps.data[slotProps.column.props.field])}}
                        </template>
                        <!-- <template #footer>
                            {{this.$formatNumber(subTotalRealQty(value.details))}}
                        </template> -->
                    </Column>
                    <Column field="UOM" header="UOM" key="Active" style="width:10%">
                    </Column>
                    <Column field="value.order.Transporter_Code" :header="$t('transporter')">
                        <template #body="">
                            {{value.order.Transporter_Code}}
                        </template>
                    </Column>
                    <Column field="value.order.Status" :header="$t('status')" class="w-2" style="white-space:unset!important">
                        <template #body="">
                            {{value.order.Status}}
                        </template>
                    </Column>
                </DataTable>
            </Fieldset>
        </div>
    </div>
    
</template>
<script>
    export default{
        name: "ShowShipment",
        props:{
            data: null,
        },
        mounted(){

        },
        methods:{
            subTotalQty(dataArray){
                var sumQty = dataArray
                                .reduce(function(tot, arr) {
                                    return tot + (arr.Qty ? arr.Qty : 0);
                                },0);   

                return sumQty;
            },
            subTotalRealQty(dataArray){
                var sumQty = dataArray
                                .reduce(function(tot, arr) {
                                    return tot + (arr.Real_Qty ? arr.Real_Qty : 0);
                                },0);   

                return sumQty;
            }        
        }
    }
</script>
<style #scoped>
    .p-fieldset-legend{
        padding: 0.3rem !important;
    }

    .p-fieldset-content{
        padding: 0.1rem !important;
    }
</style>

